import React, {FC} from 'react';

import {MessageStatusesEnum} from '../../../../../libs/shared/core/src/models/api/messageModel';
import {RecipientRolesEnum} from '../../../../../libs/shared/core/src/models/api/recipientModel';
import {CellActivity} from '../content/cell/cellActivity';
import {CellAttachmentIcon} from '../content/cell/cellAttachmentIcon';
import {CellDate} from '../content/cell/cellDate';
import {CellMiddle} from '../content/cell/cellMiddle';
import {CellRecipients} from '../content/cell/cellRecipients';
import {MessageCellCommonProps} from '../messageCellCommon';

/*
 * Props.
 */

interface MessageCellContentProps extends MessageCellCommonProps {
  teammateId: number;
  isInDraftsFolder: boolean;
}

/*
 * Component.
 */

export const MessageCellContent: FC<MessageCellContentProps> = (props) => (
  <>
    {renderTopLine(props)}
    {renderMiddleLine(props)}
    {renderBottomLine(props)}
  </>
);

/*
 * Line by line.
 */

function renderTopLine(props: MessageCellContentProps) {
  const {message, recipients, date, isSelected, reminderDate} = props;
  const receivingRecipients = recipients.filter((r) => r.role !== RecipientRolesEnum.FROM);

  return (
    <>
      <CellRecipients recipients={receivingRecipients} isSelected={isSelected} />
      {(message.status !== MessageStatusesEnum.DRAFT_SENDING && (
        <CellDate
          date={date}
          isSelected={isSelected}
          reminderDate={reminderDate}
          slaTimerDate={undefined}
          waitingSinceMs={0}
        />
      )) ||
        null}
    </>
  );
}

function renderMiddleLine(props: MessageCellContentProps) {
  const {
    message,
    conversationSubject,
    recipients,
    isSelected,
    channelTypes,
    externalChannelType,
    applicationChannelType,
  } = props;
  const recipient = recipients.find((r) => r.role === RecipientRolesEnum.TO);
  const messageSubject = message.subject;

  return (
    <CellMiddle
      messageType={message.type}
      subject={messageSubject || conversationSubject || ''}
      isSelected={isSelected}
      recipient={recipient}
      tags={[]}
      badgeValue={0}
      channelTypes={channelTypes}
      externalChannelType={externalChannelType}
      applicationChannelType={applicationChannelType}
    />
  );
}

function renderBottomLine(props: MessageCellContentProps) {
  const {message, isSelected} = props;
  const hasAttachments = message.attachments.length > 0;
  const shouldShowAttachments = hasAttachments;

  return (
    <>
      <CellActivity
        conversationId={message.conversationId}
        summary={message.blurb}
        isSelected={isSelected}
        lastCommentDraft={props.draftComment}
        lastComment={undefined}
        lastManualMessage={undefined}
        commentDraftSummary={undefined}
        draft={props.draft}
        isInDraftsFolder={props.isInDraftsFolder}
        teammateId={props.teammateId}
      />
      {shouldShowAttachments && <CellAttachmentIcon isSelected={isSelected} />}
    </>
  );
}
